<template>
<!-- Modal -->
  <div class="modale_box" :class="{'opened': modalFlag == freeTicket.ticket_id}" aria-hidden="true" @click.self="modalClose">
    <div class="modale">
      <div class="modal-dialog">
        <div class="modal-header">
          <div>
            <img style="height: 100%;" src="@/assets/member_m.png" alt="memebr.jpg">
            <h1>{{freeTicket.name}}</h1>
            <p>您好</p>
          </div>
          <a href="#" class="btn-close closemodale" @click.prevent="modalClose" aria-hidden="true">&times;</a>
        </div>
        <div class="modal-body">
          <div>
            <h2>{{freeTicket.exhibit_name}}</h2>
            <p>- {{freeTicket.ticket_name}} -</p>
            <img :src="freeTicket.qrcode_url" :alt="freeTicket.ticket_name+'_QRcode.jpg'">
            <p>請於{{exhibit_info.exhibit_date}}至{{exhibit_info.exhibit_location}}，出示此QRcode，經現場人員核對後即可入場。</p>
          </div>
          <div>
            <p><i class="fa fa-bell"></i>&nbsp;&nbsp;溫馨提醒</p>
            <ol>
              <li>請務必保存此回函，入場時請務必列印或以行動裝置出示此憑證，核對您的入場資格。</li>
              <li>一組QRcode，僅限{{exhibit_info.exhibit_date}}展期間使用乙次(兩日票券除外)，恕無法重複使用。</li>
              <li>如有疑問請與我們聯絡。</li>
              <li>大會保留活動最終解釋及更改的權力。</li>
            </ol>
          </div>
        </div>
        <div class="modal-footer">
          <hr>
          <p>如您有任何問題，請撥客服電話02-2759-7167，我們會盡最大的努力儘快作回覆。</p>
        </div>
      </div>
    </div>
  </div>
<!-- /Modal -->
</template>
<script>
export default {
  props: ["modalFlag", "freeTicket", "exhibit_info"],
  methods: {
    modalClose(){
      this.$emit('closeModal')
    }
  },
}
</script>
<style>
.btn-close {
  color: #aaaaaa;
  font-size: 20px;
  text-decoration: none;
  padding:10px;
  position: absolute;
  right: 7px;
  top: 0;
}
.btn-close:hover {
  color: #919191;
}
.modale_box {
  width: calc(100% + 17px);
  height: 100%;
  max-height: 100vh;
  display: none;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto;
  z-index: 90;
}
.opened.modale_box {
  display: block;
}
.opened .modal-dialog {
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}
.modal-dialog {
  background: #fefefe;
  border: #333333 solid 0px;
  border-radius: 25px;
  margin: auto;
  text-align: center;
  position: fixed;
  left:0;
  top: 0;
  z-index: 999;
  width: 90%;
  max-width: 450px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  transform: translate(0, -550%);
  transition: all 0.3s ease-out;
  max-height: 90vh;
  overflow: auto;
  -ms-overflow-style: none;
}
.modal-dialog::-webkit-scrollbar{ display: none;}
.modal-body {
  padding: 7px 14px;
}
.modal-body input {
  width: 200px;
  padding: 8px;
  border: 1px solid #ddd;
  color: #888;
  outline: 0;
  font-size: 14px;
  font-weight: bold;
}
.modal-header,
.modal-footer {
  padding: 10px 20px;
}
.modal-header {
  border-bottom: #eeeeee solid 1px;
}
.modal-header>div{display: flex; justify-content: left; align-content: center;}
.modal-header h1 {
  margin: 0 10px;
  display: flex;
  align-items: center;
}

/* modal內容 */
.modal-body>div:nth-of-type(1)>h2{ margin: 5px auto 10px;}
.modal-body>div:nth-of-type(1)>p:nth-of-type(1){
  font-size: 22px;
  font-weight: 600;
  margin: 5px 0;
}
.modal-body>div:nth-of-type(1)>img{
  width: 45%;
}
.modal-body>div:nth-of-type(1)>p:nth-of-type(2){
  font-size: 18px;
  margin: 5px 0;
  font-weight: 600;
  text-align: justify;
}
.modal-body>div:nth-of-type(2)>p{
  display: inline-block;
  font-size: 18px;
  border-radius: 20px;
  background-color: #333333;
  color: #ffffff;
  padding: 5px 15px;
}
.modal-body>div:nth-of-type(2)>ol{
  text-align: left;
  padding: 0 0 0 21px
}
.modal-body>div:nth-of-type(2) li{ line-height: 1.6; }
@media(max-width: 768px){
  .modal-body>div:nth-of-type(1)>h2{ font-size: 1.2rem; }
  .modal-body>div:nth-of-type(1)>p:nth-of-type(1){ font-size: 18px; }
}
@media (max-width: 450px) {
  .modal-body>div:nth-of-type(1)>img{width: 80%;}
}
</style>